module.exports = __webpack_public_path__ + "static/basiercircle-regular-23733ab3853a52bcf7d6306790b2c63c.woff";